// components/item/Item.tsx
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { ComplexOrderInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import { format } from 'date-fns'
import { useSelector } from 'react-redux'
import { ComplexOrderStatus } from '../../../../../common/types/enums'

type Props = {
  startEdit: (el: ComplexOrderInterface) => void
  el: ComplexOrderInterface
  showDetails: (el: ComplexOrderInterface) => void
}

const getStatusText = (status: ComplexOrderStatus): string => {
  const map: Record<number, string> = {
    [ComplexOrderStatus.DRAFT]: 'Новая',
    [ComplexOrderStatus.SENT_TO_MANAGER]: 'Отправлена',
    [ComplexOrderStatus.IN_PROGRESS]: 'В работе',
    [ComplexOrderStatus.APPROVED]: 'Согласована',
    [ComplexOrderStatus.CONVERTED]: 'Конвертирована',
    [ComplexOrderStatus.ARCHIVED]: 'Архив',
  }
  return map[status] || 'Неизвестно'
}

const getStatusColor = (status: ComplexOrderStatus): string => {
  const map: Record<number, string> = {
    [ComplexOrderStatus.DRAFT]: '#3498db',
    [ComplexOrderStatus.SENT_TO_MANAGER]: '#3498db',
    [ComplexOrderStatus.IN_PROGRESS]: '#f39c12',
    [ComplexOrderStatus.APPROVED]: '#2ecc71',
    [ComplexOrderStatus.CONVERTED]: '#2ecc71',
    [ComplexOrderStatus.ARCHIVED]: '#95a5a6',
  }
  return map[status] || '#95a5a6'
}

export const Item = ({ startEdit, el, showDetails }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div
      className={darkTheme ? classes.containerDark : classes.container}
      style={{
        filter: el.status === ComplexOrderStatus.ARCHIVED ? 'opacity(0.7)' : 'opacity(1)',
      }}
    >
      <div className={classes.contentContainer}>
        <div className={classes.id}>
          <div className={classes.label}>id</div>
          <div className={classes.value}>{el.id}</div>
        </div>
        <div>
          {el.createdAt && (
            <div className={classes.date}>
              <div className={classes.label}>Создана</div>
              <div className={classes.value}>
                {format(new Date(el.createdAt), 'dd.MM.yyy HH:mm')}
              </div>
            </div>
          )}
          {el.updatedAt && (
            <div className={classes.date}>
              <div className={classes.label}>Обновлена</div>
              <div className={classes.value}>
                {format(new Date(el.updatedAt), 'dd.MM.yyy HH:mm')}
              </div>
            </div>
          )}
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Позиций</div>
          <div className={classes.value}>{el.items?.length || 0}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Телефон</div>
          <div className={classes.value}>{el.phone_number || '—'}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Клиент</div>
          <div className={classes.value}>{el.customerName || '—'}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Статус</div>
          <div className={classes.value} style={{ color: getStatusColor(el.status) }}>
            {getStatusText(el.status)}
          </div>
        </div>
        {el.total > 0 && (
          <div className={classes.item}>
            <div className={classes.label}>Сумма</div>
            <div className={classes.value}>{el.total.toLocaleString('ru-RU')} ₽</div>
          </div>
        )}
      </div>

      <div className={classes.buttons}>
        <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />
        <IconButton display onClick={() => startEdit(el)} icon={edit} alt="Изменить" small />
      </div>
    </div>
  )
}
